import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlterarSenha } from 'app/models/alterar-senha.model';
import { NotificacaoService } from 'app/services/notificacao.service';
import { UsuarioService } from 'app/services/usuario.service';
import { AutenticacaoService } from 'app/services/autenticacao.service';

@Component({
    selector: 'app-alterar-senha-modal',
    templateUrl: './alterar-senha-modal.component.html',
    styleUrls: ['./alterar-senha-modal.component.css'],
    standalone: false
})
export class AlterarSenhaModalComponent {

    loading: boolean = false;
    senhaForm: FormGroup;
    ocultarSenhaAtual: boolean = true;
    ocultarNovaSenha: boolean = true;
    ocultarConfirmarSenha: boolean = true;

    constructor(
        private activeModal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private usuarioService: UsuarioService,
        private autenticacaoService: AutenticacaoService,
        private notificacaoService: NotificacaoService
    ) {
        this.senhaForm = this.formBuilder.group({
            senhaAtual: ['', Validators.required],
            novaSenha: ['', [Validators.required, Validators.minLength(6)]],
            confirmarNovaSenha: ['', Validators.required]
        });
    }

    async confirmar() {
        if (!this.senhaForm.valid) {
            this.notificacaoService.mensagemErro('Preencha corretamente todos os campos');
            return;
        }

        if (this.senhaForm.value.novaSenha !== this.senhaForm.value.confirmarNovaSenha) {
            this.notificacaoService.mensagemErro('A nova senha e a confirmação não conferem');
            return;
        }

        this.loading = true;
        try {
            const model: AlterarSenha = {
                senhaAtual: this.senhaForm.value.senhaAtual,
                novaSenha: this.senhaForm.value.novaSenha,
                confirmarNovaSenha: this.senhaForm.value.confirmarNovaSenha
            };

            const resposta = await this.usuarioService.alterarSenha(model);
            if (resposta.sucesso) {
                this.autenticacaoService.limparPrimeiroAcesso();
                this.notificacaoService.mensagemSucesso(resposta.mensagem);
                this.activeModal.close(true);
            } else {
                this.notificacaoService.mensagemErro(resposta.mensagem);
            }
        } catch (err: any) {
            this.notificacaoService.mensagemErro(err.error || 'Erro ao alterar senha');
        } finally {
            this.loading = false;
        }
    }
}
